import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppToggleGroupComponent } from './app-toggle-group.component';
import { AppToggleComponent } from './app-toggle/app-toggle.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [AppToggleGroupComponent, AppToggleComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    AppToggleComponent,
    AppToggleGroupComponent
  ]
})
export class ToggleModule { }
